var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlarnaPaymentBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 444.75,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Klarna Payment Badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(17.769 0 0 17.769 .23581 .30022)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.6843e-14,
    width: 45,
    height: 25,
    rx: 4.321,
    fill: "#ffb3c7"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0a0b09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.787 14.674c-.58875 0-1.066.48158-1.066 1.0757 0 .594.47725 1.0757 1.066 1.0757.58874 0 1.0661-.48167 1.0661-1.0757 0-.59416-.47734-1.0757-1.0661-1.0757zm-3.5073-.83166c0-.81338-.68897-1.4726-1.5389-1.4726s-1.539.65925-1.539 1.4726c0 .81339.68898 1.4728 1.539 1.4728s1.5389-.65941 1.5389-1.4728zm.0057-2.8622h1.6984v5.7242h-1.6984v-.36584c-.47982.3302-1.059.52431-1.6837.52431-1.6531 0-2.9933-1.3523-2.9933-3.0205s1.3402-3.0204 2.9933-3.0204c.6247 0 1.2039.1941 1.6837.5244v-.36619zm-13.592.74562v-.74554h-1.7389v5.7241h1.7428v-2.6725c0-.90167.96849-1.3863 1.6405-1.3863.0069 0 .01331.000667.02019.000752v-1.6656c-.68973 0-1.3241.298-1.6646.7452zm-4.3316 2.1166c0-.81338-.68905-1.4726-1.539-1.4726-.84991 0-1.539.65925-1.539 1.4726 0 .81339.68905 1.4728 1.539 1.4728.84998 0 1.539-.65941 1.539-1.4728zm.0056-2.8622h1.6985v5.7242h-1.6985v-.36584c-.47982.3302-1.059.52431-1.6836.52431-1.6532 0-2.9934-1.3523-2.9934-3.0205s1.3402-3.0204 2.9934-3.0204c.62464 0 1.2038.1941 1.6836.5244v-.36619zm10.223-.15396c-.67846 0-1.3206.21255-1.7499.79895v-.64465h-1.6911v5.7239h1.7119v-3.0081c0-.87046.57847-1.2967 1.275-1.2967.74646 0 1.1756.44996 1.1756 1.2849v3.0199h1.6964v-3.6401c0-1.3321-1.0496-2.238-2.4179-2.238zm-17.374 5.8782h1.7777v-8.2751h-1.7777zm-7.8091.0023h1.8824v-8.2789h-1.8824zm6.584-8.2789c0 1.7923-.69219 3.4596-1.9256 4.6989l2.602 3.5803h-2.325l-2.8278-3.891.72981-.55152c1.2103-.91484 1.9045-2.3132 1.9045-3.8367h1.8421z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarnaPaymentBadge);
export default __webpack_public_path__ + "static/media/Klarna_Payment_Badge.374ec453b76519bfe9224984676013ce.svg";
export { ForwardRef as ReactComponent };